export default "__VITE_ASSET__ad6baca6__"